import fetch from 'cross-fetch';
import config from './config';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export function fetchRequest(resource, init = { method: 'GET' }) {
  let headers = {};
  headers[config.api.csrftokenHeaderName] = cookies.get(config.api.csrftokenCookieName);
  headers['Content-Type'] = "application/json";
  let req = Object.assign({}, {
    headers,
  }, init);

  let url = `${config.api.baseUrl}${resource}`;
  let request = new fetch.Request(url, req);
  return fetch(request);
}
